<template>
  <div class="post" v-if="post">
    <router-link :to="`/news/${post.id}`">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="478" height="466" viewBox="0 0 478 466"><defs><clipPath :id="`${post.id}-a`"><rect width="478" height="466" transform="translate(232.977 1948)" fill="none"/></clipPath><pattern v-if="image" :id="`${post.id}-b`" width="100%" height="100%"><image x="0" y="0" :width="image.width" :height="image.height" :transform="`translate(${image.x} 0)`" :xlink:href="image.href"/></pattern><filter :id="`${post.id}-c`" x="9.74" y="29.081" width="415.19" height="453.964" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="d"/><feFlood flood-opacity="0.059"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-232.977 -1948)" :clip-path="`url(#${post.id}-a)`"><g transform="matrix(1, 0, 0, 1, 232.98, 1948)" :filter="`url(#${post.id}-c)`"><path v-if="image" d="M-3.507,108.994C54.693,32.785,143.042-33.2,214.553,55.247s101.631,229.6,53.129,294.117S88.37,376.1,20.544,313.327-61.707,185.2-3.507,108.994Z" transform="translate(91.57 44.16)" :fill="`url(#${post.id}-b)`"/></g><path d="M52.024,65.007C131.378-34.7,217.6-12.679,292.072,83.294S138.88,503.023,64.408,407.05-27.33,164.71,52.024,65.007Z" transform="translate(445.293 1947.735) rotate(30)" fill="#f77e0b" opacity="0.12"/><path d="M13.107-5.478c5.7.5,10.633,9.507,9.668,15.392s-8.862,8.148-13.526,8.148S-.991,13.617-.037,7.932,7.4-5.974,13.107-5.478Z" transform="translate(284.886 2058.969)" fill="#f77e0b" opacity="0.12"/><path d="M20.23.033c8.706.756,16.232,14.513,14.76,23.5S21.46,35.969,14.34,35.969-1.292,29.184.164,20.506,11.523-.723,20.23.033Z" transform="translate(624.264 2287.032) rotate(-60)" fill="#f77e0b" opacity="0.12"/></g></svg>
    </router-link>
    <div class="post-author">{{post.author.name}}<span> - </span><DateFormat format="%lm %d, %Y" :date="post.date.toDate()" /></div>
    <div class="post-title" ref="title"><span>{{post.title}}</span></div>
    <router-link class="post-read" :to="`/news/${post.id}`"><span class="text">Read the full story</span><span class="plus">+</span></router-link>
  </div>
</template>

<script>
import DateFormat from './DateFormat'

export default {
  name: 'NewsItem',
  components: {
    DateFormat
  },
  props: {
    post: {
      type: Object
    },
  },
  data() {
    return {
      image: null
    }
  },
  watch: {
    post(p) {
      if(p) {
        this.loadImage(p.image)
        this.sizeTitle()
      }
    }
  },
  methods: {
    loadImage(src) {
      this.$nextTick(() => {
        const img = new Image()
        img.onload = () => {
          const imgHeight = 466
          const ratio = imgHeight / img.height
          const width = img.width * ratio
          this.image = {
            href: img.src,
            width: width,
            height: imgHeight,
            x: 0
          }
          img.remove()
        }
        img.onerror = () => this.image = null
        img.src = src
      })
    },
    sizeTitle() {
      this.$nextTick(() => {
        const container = this.$refs.title.querySelector('span')
        for(let size = 100; size >= 10; size--) {
          if(this.$refs.title.clientHeight >= container.clientHeight) break
          container.style.fontSize = `${size}px`
        }
      })
    }
  },
  mounted: function() {
    if(this.post) {
      this.loadImage(this.post.image)
      this.sizeTitle()
    }
    window.addEventListener('resize', this.sizeTitle)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.sizeTitle)
  }
}
</script>

<style scoped>
.post {
  text-align: center;
}

.post svg {
  display: block;
  width: 100%;
  height: auto;
}

.post .post-image {
  height: 410px;
  max-width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 0 auto 26px;
}

.post .post-author {
  font-size: .72em;
  letter-spacing: .58em;
  opacity: .77;
  text-transform: uppercase;
}

.post .post-title {
  position: relative;
  font: bold 2.28em/1 'Butler';
  padding: 0 20%;
  margin: 14px 0 42px;
  overflow: hidden;
  height: 100px;
}

.post .post-title span {
  display: block;
  line-height: 1.1875;
}

.post .post-read {
  position: relative;
  display: inline-block;
  width: 240px;
  color: #F77E0B;
  font-size: .72em;
  letter-spacing: .58em;
  text-transform: uppercase;
  text-align: left;
}

.post .post-read:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: rgba(247, 125, 11, .25);
  transition: width .16s ease-out;
  margin: 4px auto 0;
}

.post .post-read .plus {
  position: absolute;
  right: 0;
  bottom: 5px;
  letter-spacing: 0;
  transition: opacity .16s ease-out .08s;
}

.post .post-read .text {
  display: inline-block;
  transition: transform .16s ease-out;
  will-change: transform;
}

@media screen and (min-width: 1025px) {
  .post .post-read:hover:after {
    transition: width .24s ease-out .16s;
    width: 210px;
  }
  .post .post-read:hover .text {
    transition: transform .16s ease-in-out .08s;
    transform: translateX(16px);
  }
  .post .post-read:hover .plus {
    transition: opacity .16s ease-out;
    opacity: 0;
  }
}

@media screen and (max-width: 1024px) {
  .post .post-author span:not(.date-format) {
    font-size: 0;
    display: block;
  }
  .post .post-title {
    margin-bottom: 20px;
  }
}
</style>
